// This file provides an interface for all our api services defined in the services file of each module.
import axios from 'axios';
import Auth from './Auth';
import { getApiErrorMessage } from './handleApiError';

export const baseUrl = process.env.REACT_APP_BASE_API_URL;

const Api = axios.create({
  baseURL: baseUrl
});

Api.interceptors.request.use(
  (config) => {
    // This adds an authorization key to config object if a token exists.
    if (Auth.isAuthenticated()) {
      // eslint-disable-next-line
      config.headers.Authorization = `Bearer ${Auth.getToken()}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// This ensures that appropriate error message from the API are parsed to react query
Api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && Auth.isAuthenticated()) {
      Auth.logOut();
    }

    const data = error.response?.data;
    if (typeof data === 'string' && /<\/?[a-z][\s\S]*>/i.test(data)) {
      const apiError = new Error(
        error.response.status === 404 ? 'The requested resource was not found' : 'Something went wrong'
      );
      apiError.status = error.response.status;
      return Promise.reject(apiError);
    }

    if (data && typeof data === 'object') {
      const apiError = new Error(getApiErrorMessage(data));
      Object.assign(apiError, data);
      return Promise.reject(apiError);
    }

    if (typeof data === 'string') {
      return Promise.reject(new Error(data));
    }

    return Promise.reject(error);
  }
);

export default Api;
